import React, { createContext, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ConnectionsUI, getUnsupportedMarketplaces } from '@shipstation/connections-ui';
import { useCommonCuiProps } from '../connection-components/helpers/use-common-cui-props';

export const CUIContext = createContext();
export const useCUIContext = () => useContext(CUIContext);

export const CUIContextProvider = ({ children }) => {
  const commonCuiProps = useCommonCuiProps();
  const [unsupportedMarketplaces, setUnsupportedMarketplaces] = useState(new Set());
  const value = useMemo(() => ({ unsupportedMarketplaces }), [unsupportedMarketplaces]);

  return (
    <>
      <ConnectionsUI
        {...commonCuiProps}
        onInitialized={() => getUnsupportedMarketplaces().then((marketplaces) => setUnsupportedMarketplaces(new Set(marketplaces)))}
      />
      <CUIContext.Provider value={value}>{children}</CUIContext.Provider>
    </>
  );
};

CUIContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
